import { extractToken } from "../../../services/authorization";

let user = {};
const token = localStorage.getItem("token") || false;
if (token && token !== "null") {
  user = extractToken({ access_token: token });
}

const initialState = {
  isTokenExpired: false,
  selectedMenu: "collection",
  authorities: {},
  user,
};
export default initialState;
